import { CompanyMiniDto } from 'src/app/domain/recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { OrgMiniDTO } from 'src/app/domain/recovery/dto/OrgMiniDTO';
import { LocalDate } from '../../../core/pojo/date-variable';

export interface MetricSharedLinkWrapper {
  uuid?: string;
  companyUUID: string;
  actual: MetricSharedLinkPlanning;
  budget: MetricSharedLinkPlanning;
  contact: MetricSharedLinkContact;
  password?: string;
  token?: string;
  lastModifiedDate?: Date;
  creationDate?: Date;
}

export interface MetricSharedLinkPlanning {
  isActivated: boolean;
  fromPeriod: LocalDate;
  tillPeriod: LocalDate;
}

export interface MetricSharedLinkContact {
  isActivated: boolean;
  name: string;
  email: string;
}

export class SharedLinkPeriods {
  from: LocalDate[];
  till: LocalDate[];
  all: LocalDate[];
}

export interface MetricSharedLinkRelatedInfo {
  org: OrgMiniDTO;
  company: CompanyMiniDto;
}
